import React, { useMemo, useState } from "react";
import { BookCheck } from "lucide-react";

import { useAppSelector } from "../../../app/hooks";
import AccountsModal from "../../accounts/components/AccountsModal";
import AccountPopoverRow from "../../accounts/components/AccountPopoverRow";
import { getCaseAccounts } from "../../accounts/logic/slice";
import { InvestigationEntityCard } from "./InvestigationEntityCard";
import { EntityModalType } from "./LoanAccountCard";

const AccountsCard: React.FC = () => {
  const accounts = useAppSelector(getCaseAccounts);
  const [activeModal, setActiveModal] = useState<EntityModalType | null>(null);

  const accountItems = useMemo(
    () => accounts.map((account) => account.ext_account_number),
    [accounts],
  );

  const closeModal = () => {
    setActiveModal(null);
  };

  return (
    <>
      <InvestigationEntityCard
        title="Accounts"
        items={accountItems}
        onAdd={() => setActiveModal(EntityModalType.ADD)}
        onManage={() => setActiveModal(EntityModalType.MANAGE)}
        popoverProps={{
          title: "Accounts",
          icon: <BookCheck size={16} className="text-[#94A3B8]" />,
          items: accounts.map((account, index) => ({
            content: (
              <AccountPopoverRow account={account} showDivider={index > 0} />
            ),
            copyValue: account.ext_account_number,
          })),
        }}
        emptyState={{
          icon: <BookCheck size={18} className="text-[#94A3B8]" />,
          message: "No accounts added",
        }}
      />

      {activeModal && (
        <AccountsModal
          onClose={closeModal}
          onBack={closeModal}
          prefillExisting={activeModal === EntityModalType.MANAGE}
          title={
            activeModal === EntityModalType.MANAGE
              ? "Manage Accounts"
              : "Add Accounts"
          }
        />
      )}
    </>
  );
};

export default AccountsCard;
